import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.addSupplementToInquiry;
export const addSupplementToInquiryIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
